/* ----------------------
    Longitude Advert Settings:
*/
export const mobileTopMPU1Id = "ad-mobileTopMpu1";
